module.exports = __webpack_public_path__ + "static/media/userIcon.cb530214.svg";